import * as Yup from 'yup';

const RecalculationSchema = Yup.object()
    .shape({
        end: Yup.date().nullable()
            .min(
                Yup.ref('start'),
                'End date must be after the start date.'
            ),
        start: Yup.date().nullable()
    });

export default RecalculationSchema;
